import React, { Component } from "react";
import { connect } from "react-redux";
import { quiz3DataWatch, quiz3DataUpdate } from "../../actions/quiz3Actions";

import produce from "immer";
import _ from "lodash";

class ViewData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: []
    };
  }

  componentDidMount() {
    const { data } = this.props || {};

    if (_.isEmpty(data)) {
      this.props.quiz3DataWatch();
    } else {
      this.setState(
        produce(draft => {
          draft.data = data;
        })
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { data: prevData } = prevProps;
    const { data: currData } = this.props;
    if (!_.isEqual(prevData, currData)) {
      this.setState(
        produce(draft => {
          draft.data = currData;
          return draft;
        })
      );
    }
  }

  handleChange = (idx, e) => {
    const { value, name } = e.target;
    switch (name) {
      case "no":
        this.setState(
          produce(draft => {
            draft.data[idx][name] = Number.parseInt(value);
          })
        );
        break;
      case "question":
      case "ex":
      case "answer":
      case "explanation":
        this.setState(
          produce(draft => {
            draft.data[idx][name] = value;
          })
        );
        break;

      default:
        break;
    }
  };

  handleSubmit = (idx, e) => {
    e.preventDefault();
    console.log("submit", idx, this.state.data[idx]);

    this.props.quiz3DataUpdate(idx, this.state.data[idx]);
  };

  renderRow = data => {
    const { data: prevData } = this.props;

    return data.map((d, idx) => (
      <div key={idx} className="row my-5">
        <div className="col-12">
          <form onSubmit={e => this.handleSubmit(idx, e)} className="row">
            {/* NO */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <input
                className="d-block w-100"
                type="text"
                name="no"
                value={d.no}
                onChange={e => this.handleChange(idx, e)}
                readOnly
              />
            </div>

            {/* QUESTION && EXAMPLES && EXPLANATION CONTAINER */}
            <div className="col-10">
              <div className="row">
                {/* QUESTION */}
                <div className="col-12 d-flex justify-content-between align-items-center my-1">
                  <input
                    className="d-block w-100"
                    type="text"
                    name="question"
                    value={d.question}
                    onChange={e => this.handleChange(idx, e)}
                    readOnly
                  />
                </div>

                {/* EXAMPLE */}
                <div className="col-12 d-flex justify-content-between align-items-center my-1">
                  <textarea
                    rows="3"
                    className="d-block w-100"
                    type="text"
                    name="ex"
                    value={d.ex}
                    onChange={e => this.handleChange(idx, e)}
                  />
                </div>

                {/* ANSWER */}
                <div className="col-12 d-flex justify-content-between align-items-center my-1">
                  <input
                    className="d-block w-100"
                    type="text"
                    name="answer"
                    value={d.answer}
                    onChange={e => this.handleChange(idx, e)}
                  />
                </div>

                {/* EXPLANATION */}
                <div className="col-12 d-flex justify-content-between align-items-center my-1">
                  <input
                    className="d-block w-100"
                    type="text"
                    name="explanation"
                    value={d.explanation}
                    onChange={e => this.handleChange(idx, e)}
                  />
                </div>
              </div>
            </div>

            {/* SUBMIT */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <button
                type="submit"
                className="d-block w-100 btn btn-danger btn-block"
                style={{ height: "100%" }}
                disabled={_.isEqual(data[idx], prevData[idx])}
              >
                수정
              </button>
            </div>
          </form>
        </div>
      </div>
    ));
  };

  render() {
    const { data } = this.state;
    return <div>{this.renderRow(data)}</div>;
  }
}

const mapStateToProps = state => ({
  data: state.quiz3.data
});

export default connect(
  mapStateToProps,
  { quiz3DataWatch, quiz3DataUpdate }
)(ViewData);
